import { AdminRouteName } from '../../../CONSTANTS';
import EquifaxReportsTableRecords from '../EquifaxReportsTableRecords';

const SubmittedEquifaxReports = () => (
  <EquifaxReportsTableRecords
    optionalColumn={['createdAt']}
    optionalColumnLabelFormat={{
      createdAt: 'Date created',
    }}
    tabStatus="SUBMITTED"
    defaultUrl={AdminRouteName.equifaxSubmittedReportRoute}
    toggleStorageId="submitted_equifax-reports-table-col"
    hasNameAndImage
    permissionName="can-update-rent-payment-settlement-status"
  />
);
export default SubmittedEquifaxReports;
